import React, {useState} from 'react';
import CustomMenu from "./CustomMenu";
import {isMobile} from "../../services/Helpers";
import CustomDrawer from "./CustomDrawer";
import uuid from "react-native-uuid";
import CustomButtonExtended from "./CustomButtonExtended";
import {Divider} from "antd";
import {GlobalConsts} from "../../styles/GlobalConsts";

const ResponsiveMenu = (props) => {
    const { items, anchor, containerDOM, ...rest } = props;
    const [menuOpen, setMenuOpen] = useState(false);
    const [childrenMenuOpen, setChildrenMenuOpen] = useState(false)
    const [children, setChildren] = useState(null)

    const onActionClicked = (item) => {
        setMenuOpen(false)
        if(item.children) {
            setChildren(item.children)
            setChildrenMenuOpen(true)
        } else {
            item.onPress(item)
        }
    }

    //TODO: MOBILE LOCK HANDLING (AFTER REPLACING CustomButtonExtended)

    return (
        <>
            {isMobile ?
                <div onClick={() => setMenuOpen(true)} {...rest}>{anchor}</div>
                :
                <CustomMenu items={items} anchor={anchor} {...rest}/>
            }
            {menuOpen &&
            <CustomDrawer open={isMobile && menuOpen}
                          placement={'bottom'}
                          style={{borderTopLeftRadius: 30, borderTopRightRadius: 30}}
                          getContainer={containerDOM || '#native-base-main-view'}
                          onClose={() => setMenuOpen(false)}>
                <div style={{flex: 1, maxHeight: '400px'}}>
                    {
                        items && items.map((item) => (
                            item.override ? item.override :
                            <React.Fragment key={uuid.v4()}>
                                { item.type === 'divider' ?
                                    <Divider style={{margin: '5px 0'}}/>
                                    :
                                    <CustomButtonExtended title={item.title}
                                                          iconName={item.iconName}
                                                          iconSize={item.iconSize || GlobalConsts.iconSize.XS}
                                                          textStyles={{fontSize: '1rem'}}
                                                          w={'100%'}
                                                          buttonId={item.id}
                                                          leftStyles={{px:'2px'}}
                                                          {...item}
                                                          onPress={() => onActionClicked(item)} //for overriding the item onPress

                                    />
                                }
                            </React.Fragment>
                        ))
                    }
                </div>
            </CustomDrawer>
            }
            {childrenMenuOpen &&
                <CustomDrawer open={isMobile && childrenMenuOpen}
                              placement={'bottom'}
                              style={{borderTopLeftRadius: 30, borderTopRightRadius: 30}}
                              onClose={() => setChildrenMenuOpen(false)}>
                    <div style={{flex: 1, maxHeight: '400px'}}>
                        {
                            children && children.map((item) => (
                                <React.Fragment key={uuid.v4()}>
                                    { item.type === 'divider' ?
                                        <Divider style={{margin: '5px 0'}}/>
                                        :
                                        <CustomButtonExtended title={item.title}
                                                              iconName={item.iconName}
                                                              iconSize={GlobalConsts.iconSize.XS}
                                                              textStyles={{fontSize: '1rem'}}
                                                              w={'100%'}
                                                              buttonId={item.id}
                                                              leftStyles={{px:'2px'}}
                                                              {...item}
                                                              onPress={() => onActionClicked(item)} //for overriding the item onPress

                                        />
                                    }
                                </React.Fragment>
                            ))
                        }
                    </div>
                </CustomDrawer>

            }
        </>
    );
};

export default ResponsiveMenu;